export const L10N = {
  ACTION_MORE_INFO: { id: 'common.action.more_info' },
};
